import React, { useMemo } from "react";
import { AtSign, MessageCircle, MessageSquare } from "react-feather";
import { HELP_SUPPORT_COPY as COPY } from "../components/organisms/FeedbackDialog/FeedbackDialog.copy";
import type { SidebarProfileChipSection } from "../components/organisms/SidebarProfileChip";
import { useHelpSupport } from "./useHelpSupport";

/** Opens a support link: a mailto: in the mail app, anything else in a new tab. */
const openSupport = (url: string) => {
  if (url.startsWith("mailto:")) window.location.href = url;
  else window.open(url, "_blank", "noreferrer");
};

/** The Help & support section of the avatar menu: Live chat, Send feedback, Email us. */
export const useHelpSupportSections = (): SidebarProfileChipSection[] => {
  const help = useHelpSupport();
  const { liveChatAvailable, openLiveChat, openFeedback, supportUrl, supportAddress } = help;
  return useMemo(
    () => [
      {
        id: "help-support",
        label: COPY.section,
        soonLabel: COPY.soon,
        items: [
          {
            id: "live-chat",
            label: COPY.liveChat,
            icon: <MessageCircle size={16} aria-hidden="true" />,
            status: liveChatAvailable ? COPY.online : undefined,
            soon: !liveChatAvailable,
            onSelect: openLiveChat,
          },
          { id: "feedback", label: COPY.feedback, icon: <MessageSquare size={16} aria-hidden="true" />, hint: COPY.feedbackHint, onSelect: openFeedback },
          { id: "email", label: COPY.email, icon: <AtSign size={16} aria-hidden="true" />, hint: supportAddress, onSelect: () => openSupport(supportUrl) },
        ],
      },
    ],
    [liveChatAvailable, openLiveChat, openFeedback, supportUrl, supportAddress],
  );
};
